import React, { useMemo } from 'react';
import Chart from 'react-apexcharts';
import useMeterField from '../useMeterField';

const DEMO_DATA = [0, 0, 0, 0, 0, 0, 0, 0, 0];

const SparklineWidget = ({ config }) => {
    const { settings = {}, dataSource = {}, title } = config;
    const isPreview = typeof config.id === 'string' && config.id.startsWith('preview-');
    const report = useMeterField(title, { meterId: settings.meterId, skip: Boolean(dataSource.endpoint) || isPreview });
    const reportData = report.field && report.points.length ? report.points.map((p) => Number(p.value) || 0) : null;

    const data = dataSource.data || reportData || DEMO_DATA;
    const latest = data[data.length - 1];
    const first = data[0];
    const delta = first ? Number((((latest - first) / first) * 100).toFixed(1)) : 0;
    const isUp = delta >= 0;

    const unit = settings.unit || '';
    const color = settings.color || '#4318FF';
    const options = useMemo(() => ({
        chart: { sparkline: { enabled: true } },
        stroke: { curve: 'smooth', width: 2 },
        colors: [color],
        tooltip: {
            enabled: true,
            marker: { show: false },
            x: { show: false },
            y: { title: { formatter: () => '' }, formatter: (v) => `${v}${unit ? ` ${unit}` : ''}` },
        },
        fill: { type: 'gradient', gradient: { opacityFrom: 0.35, opacityTo: 0 } },
    }), [color, unit]);

    return (
        <div className="sparkline-widget">
            <div className="sparkline-widget__header">
                <div className="sparkline-widget__value">{latest}{settings.unit ? ` ${settings.unit}` : ''}</div>
                <div className={`sparkline-widget__delta${isUp ? ' sparkline-widget__delta--up' : ' sparkline-widget__delta--down'}`}>
                    <i className={`fas fa-arrow-${isUp ? 'up' : 'down'}`}></i> {Math.abs(delta)}%
                </div>
            </div>
            <div className="sparkline-widget__chart">
                <Chart options={options} series={[{ data }]} type="area" height="60" width="100%" />
            </div>
        </div>
    );
};

export default SparklineWidget;
